export const faqNav = (t) => [
  { title: t("general"), value: "general" },
  { title: t("financial"), value: "finance" },
  { title: t("technical"), value: "technical" },
];
